/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type EducationJourneyProgramStatusResponse = {
    /**
     * The name of the task program
     */
    taskProgramName: string;
    /**
     * The current status of the education journey
     */
    journeyStatus: EducationJourneyProgramStatusResponse.journeyStatus;
    /**
     * Indicates whether there are available modules for this education journey
     */
    hasAvailableModules: boolean;
};

export namespace EducationJourneyProgramStatusResponse {

    /**
     * The current status of the education journey
     */
    export enum journeyStatus {
        LOCKED = 'LOCKED',
        AVAILABLE = 'AVAILABLE',
        IN_PROGRESS = 'IN_PROGRESS',
        COMPLETED = 'COMPLETED',
    }


}

